<template>
    <div>
        <section class="top-panel bg-deveo-gradient">
            <div class="container">
                <h1>
                    CORE
                </h1>
                <div style="height:300px"></div>
            </div>
        </section>
        <img src="http://iqonicthemes.com/themes/sofbox/v1/images/banner/02.png" style="width:102%;height:60px;margin-top:-86px;z-index:99"/>
        <section class="bg-deveo-white">
            <div class="container" style="min-height: 400px;position:relative;">
                <img class="hello" src="/static/images/core.svg" style="width:300px"/>
                <img src="http://iqonicthemes.com/themes/sofbox/v1/images/banner/01.png" style="width:50%;position:absolute;right:0;top:-400px;"/>
            </div>
        </section>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                language: 'hejsa'
            }
        }
    }
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// index.vue?4cf75482